import { Component, OnInit } from '@angular/core';
import { SignupService } from 'src/app/services/signup.service';
import { WatcherService } from 'src/app/services/watcher.service';
@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.css']
})
export class AboutComponent implements OnInit {

  constructor(
    public signUpService: SignupService,
    private watcherService: WatcherService
  ) { }

  lang;
  hostCountriesCount = Number(localStorage.getItem('hostCountriesCount')) ?? 40;
  ngOnInit(): void {

    this.hostCountriesCount = Number(localStorage.getItem('hostCountriesCount')); 

    if(!this.hostCountriesCount){
      this.signUpService.getHostCountries().subscribe(list => {
        this.hostCountriesCount = list["data"].length;
      })
    }


    this.watcherService.getLang().subscribe(
      lang => {
        this.lang = lang;
      }
    )
  }
}